import Link from 'next/link';

export default function ProgramContent () {
  return (
    <section className="relative">
      <img src="/images/decoration/circlesGroupGreen.svg" alt="decoration" className="hidden md:block absolute -top-[64px] -left-0 scale-x-[-1]"/>  
      <div className="relative mx-auto py-8 px-8 bigscreen-responsive md:px-0">
        <img src="/images/chefProgramas.jpg" alt="Chef" className="hidden xl:block xl:absolute xl:top-0 -right-10 rounded-[40px] " />
        <h2 className="text-center font-bold text-xl max-w-sm md:text-3xl md:text-start md:mx-32">Todos nuestros programas incluyen:</h2>
        <p className="mt-4 px-4 py-3 text-center text-[#637381] text-sm max-w-sm md:px-0 md:py-6 md:text-start md:max-w-xl md:text-lg md:mx-32">En Amura, nos preocupamos por brindarte una experiencia educativa completa y de calidad. Por eso, nuestros programas incluyen:</p>
        <ul className="flex flex-col items-center text-[#637381] text-sm md:text-lg md:items-start md:mx-32">
          <li className="flex items-center mb-2">
            <span className="bg-orange-light rounded-full h-1.5 w-1.5 mr-4"/>
            <p>Material didáctico de apoyo.</p>
          </li>
          <li className="flex items-center mb-2">
            <span className="bg-orange-light rounded-full h-1.5 w-1.5 mr-4"/>
            <p>Ingredientes frescos y de la mejor calidad.</p>
          </li>
          <li className="flex items-center mb-2">
            <span className="bg-orange-light rounded-full h-1.5 w-1.5 mr-4"/>
            <p>Póliza de seguro.</p>
          </li>
          <li className="flex items-center mb-2">
            <span className="bg-orange-light rounded-full h-1.5 w-1.5 mr-4"/>
            <p>Parqueo seguro y exclusivo.</p>
          </li>
          <li className="flex items-center mb-2">
            <span className="bg-orange-light rounded-full h-1.5 w-1.5 mr-4"/>
            <p>Bolsa de empleo.</p>
          </li>
          <li className="flex justify-center md:justify-start w-full mt-6">
            <Link href='https://wa.me/50662236864' target='_blank' className="text-center font-bold text-sm text-white rounded-full py-3 px-6 shadow-sm bg-gradient-to-r from-[#FBA919] to-[#F68729] hover:shadow-lg md:text-nowrap cursor-pointer">
              Contactanos hoy mismo
            </Link>
          </li>
        </ul>
      </div>
    </section>
  );
}